import { CleaningServices } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { keyframes } from '@emotion/react';
import React, { useState } from 'react';

const shake = keyframes`
  0% { transform: rotate(0deg); }
  20% { transform: rotate(-10deg); }
  40% { transform: rotate(10deg); }
  60% { transform: rotate(-6deg); }
  80% { transform: rotate(6deg); }
  100% { transform: rotate(0deg); }
`;

function CleanningButton({
  onClick,
  tooltipText = "Limpiar filtros",
  iconColor = "inherit",
  paddingBottom = "15px"
}) {
  const [shakeAnimation, setShakeAnimation] = useState(false);

  const handleClick = () => {
    if (onClick) onClick();

    setShakeAnimation(true);
    setTimeout(() => setShakeAnimation(false), 500);
  };

  return (
    <Tooltip title={tooltipText}>
      <IconButton
        onClick={handleClick}
        sx={{
          marginBottom: paddingBottom,
          transition: 'transform 0.3s ease',
          '&:hover': {
            transform: 'rotate(15deg)',
          },
          animation: shakeAnimation ? `${shake} 0.5s` : 'none',
        }}
      >
        <CleaningServices sx={{ color: iconColor }} />
      </IconButton>
    </Tooltip>
  );
}

export default CleanningButton;